import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AlarmsResponse } from '/app/alarms/models/alarm.model';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlarmsService } from '/app/alarms/services/alarms.service';

@Component({
  selector: 'app-lastposicion-monitor',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSlideToggleModule, MatProgressSpinnerModule],
  providers: [DatePipe],
  templateUrl: './lastposicionMonitor.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lastposicionMonitor.component.css']
})
export class LastposicionMonitorComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() lastPositions: any[] = [];
  @Input() alarmsByAssetId: { [key: string]: any[] } = {};
  @Input() isRiskEvaluation: boolean = false;
  @Input() clusteringEnabled: boolean = true;
  @Input() alarms: any[] = [];
  @Input() totalAlarms: number = 0;
  @Input() isLoadingAlarms: boolean = false;
  @Input() monitorId: string | null = null;
  @Input() newAlarmIds: Set<string> | null = null;
  @Input() selectedAlarmId: string | null = null;
  @Input() onRowClick?: (alarm: any) => void;
  @Output() vehicleSelected = new EventEmitter<{ latitude: number; longitude: number; assetName: string; assetId: string; color?: string; alarmData?: any }>();
  @Output() lastPositionsUpdated = new EventEmitter<any[]>();
  @Output() toggleClusteringEvent = new EventEmitter<void>();
  @Output() loadMoreAlarms = new EventEmitter<void>();
  @Output() filteredAssetIdsChange = new EventEmitter<string[] | null>();

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  private scrollListener: (() => void) | null = null;
  columns: string[] = [];
  columnLabels: { [key: string]: string } = {};
  allAvailableColumns: string[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  sortBy: string | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';
  displayedPositions: any[] = [];
  alarmasDisplayHoy: any[] = [];
  private previousDisplayedPositions: any[] = [];
  private previousSortedPositions: any[] = [];
  // track previous new alarm ids to detect additions
  private previousNewAlarmIds: Set<string> = new Set<string>();
  private audioCtx: AudioContext | null = null;
  private audioTimer: any = null;

  // ---- Filtros de alarmas ----
  filterText: string = '';
  showFilters: boolean = false;
  filteredAlarms: any[] = [];
  availableUnits: { assetId: string; assetName: string }[] = [];
  selectedUnits: Set<string> = new Set();
  unitSearchText: string = '';

  classificationForm!: FormGroup;
  statusOptions: Array<{ value: string; label: string }> = [];
  errorMessage: string | null = null;
  successMessage: string | null = null;
  // Pagination / loading helpers used by onBulkChange
  pageSize: number = 15;
  currentPage: number = 0;
  isLoadingMore: boolean = false;
  hasMorePages: boolean = false;

  // ---- Bulk alarm selection ----
  bulkAlarms: any[] = [];
  selectedAlarmIds: Set<string> = new Set();
  bulkCurrentPage: number = 0;
  bulkHasMorePages: boolean = false;
  isLoadingBulkAlarms: boolean = false;
  bulkTotalElements: number = 0;

  constructor(private datePipe: DatePipe, private fb: FormBuilder, private alarmsService: AlarmsService) {}

  ngOnInit(): void {
    this.initializeColumns();
    
    // Inicializar formulario de clasificación
    this.classificationForm = this.fb.group({
      status: ['', Validators.required],
      observations: ['', Validators.required],
      bulkClassification: [false]
    });


    this.statusOptions = [
    { value: 'Alarma Atrasada', label: 'Alarma Atrasada' },
    { value: 'Alarma Clasificación Automática', label: 'Alarma Clasificación Automática' },
    { value: 'Alarma Verdadero', label: 'Alarma Verdadero' },
    { value: 'Alarma en Falso', label: 'Alarma en Falso' },
    { value: 'Alarmas Pendientes de Trato', label: 'Alarmas Pendientes de Trato' },
    { value: 'Cliente Inactivo', label: 'Cliente Inactivo' },
    { value: 'Cliente a Desinstalar', label: 'Cliente a Desinstalar' },
    { value: 'Cliente en Stand By', label: 'Cliente en Stand By' },
    { value: 'Conductor Fumando', label: 'Conductor Fumando' },
    { value: 'Detección de Cansancio', label: 'Detección de Cansancio' },
    { value: 'Detección de Distracción', label: 'Detección de Distracción' },
    { value: 'Detección de Fatiga', label: 'Detección de Fatiga' },
    { value: 'Detección de Uso de Teléfono', label: 'Detección de Uso de Teléfono' },
    { value: 'En Duda', label: 'En Duda' },
    { value: 'Error de Manipulación', label: 'Error de Manipulación' },
    { value: 'Falsa Alarma con Activación Policial', label: 'Falsa Alarma con Activación Policial' },
    { value: 'Móvil Inactivo', label: 'Móvil Inactivo' },
    { value: 'Móvil Observado', label: 'Móvil Observado' },
    { value: 'Móvil a Desinstalar', label: 'Móvil a Desinstalar' },
    { value: 'Móvil en Base Cliente', label: 'Móvil en Base Cliente' },
    { value: 'Móvil en Centro', label: 'Móvil en Centro' },
    { value: 'Notificado a Contacto', label: 'Notificado a Contacto' },
    { value: 'Otro', label: 'Otro' },
    { value: 'Probable Falla', label: 'Probable Falla' },
    { value: 'Prueba Atención Servicios', label: 'Prueba Atención Servicios' },
    { value: 'Prueba de Servicios', label: 'Prueba de Servicios' },
    { value: 'Sin Contacto', label: 'Sin Contacto' }
  ];



    // this.statusOptions = [
    //   { value: 'RECOGNIZED', label: 'Reconocida' },
    //   { value: 'FALSE_POSITIVE', label: 'Falsa' },
    //   { value: 'VALIDATED', label: 'Validada' }
    // ];
  }

  ngAfterViewInit(): void {
    this.setupInfiniteScroll();
  }

  ngOnDestroy(): void {
    this.removeScrollListener();
    try {
      if (this.audioCtx) {
        try { this.audioCtx.close(); } catch (_e) {}
        this.audioCtx = null;
      }
      if (this.audioTimer) {
        clearTimeout(this.audioTimer);
        this.audioTimer = null;
      }
    } catch (e) {
      // ignore
    }
  }

  private playNewAlarmSound(): void {
    try {
      const AudioCtx = (window as any).AudioContext || (window as any).webkitAudioContext;
      if (!AudioCtx) return;
      if (!this.audioCtx) this.audioCtx = new AudioCtx();
      if (!this.audioCtx) return;
      const ctx: any = this.audioCtx;

      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(880, ctx.currentTime); // A5
      g.gain.setValueAtTime(0, ctx.currentTime);
      o.connect(g);
      g.connect(ctx.destination);

      const now = ctx.currentTime;
      g.gain.linearRampToValueAtTime(0.12, now + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.45);
      o.start(now);
      // stop after short duration
      this.audioTimer = setTimeout(() => {
        try { o.stop(); } catch (_e) {}
        if (this.audioTimer) { clearTimeout(this.audioTimer); this.audioTimer = null; }
      }, 500);
    } catch (e) {
      // ignore audio errors
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    // Construir set de assetIds correspondientes a las alarmas marcadas como nuevas
    try {
      this._newAlarmAssetIds = new Set<string>();
      if (this.newAlarmIds && this.alarms && this.alarms.length > 0) {
        this.alarms.forEach((a: any) => {
          if (a && a.id && this.newAlarmIds!.has(a.id)) {
            const aid = a.gpsReport?.assetId || a.deviceId || null;
            if (aid) this._newAlarmAssetIds.add(aid);
          }
        });
      }
    } catch (e) {
      // ignore
    }

    // Detectar nuevas alarmas (ids añadidos) y reproducir sonido breve
    try {
      const currentNewIds = new Set<string>((this.newAlarmIds && Array.from(this.newAlarmIds)) || []);
      const added: string[] = [];
      currentNewIds.forEach(id => {
        if (!this.previousNewAlarmIds.has(id)) added.push(id);
      });
      if (added.length > 0) {
        this.playNewAlarmSound();
      }
      this.previousNewAlarmIds = currentNewIds;
    } catch (e) {
      // ignore
    }

    // Si cambió el selectedAlarmId, resolver assetId y centrar/seleccionar
    if (changes['selectedAlarmId']) {
      try {
        this.updateSelectedFromInput();
      } catch (e) {
        // ignore
      }
    }

    let shouldProcess = false;

    if (changes['lastPositions']) {
      const current = changes['lastPositions'].currentValue;
      const previous = changes['lastPositions'].previousValue;
      if (!previous || current.length !== previous.length || JSON.stringify(current) !== JSON.stringify(previous)) {
        shouldProcess = true;
      }
    }

    if (changes['alarmsByAssetId']) {
      const current = changes['alarmsByAssetId'].currentValue;
      const previous = changes['alarmsByAssetId'].previousValue;
      if (!previous || Object.keys(current).length !== Object.keys(previous).length || JSON.stringify(current) !== JSON.stringify(previous)) {
        shouldProcess = true;
      }
    }

    if (shouldProcess) {
      this.processPositions();
      this.updateAvailableUnits();
    }

    if (changes['alarms']) {
      this.applyFilters();
      if (this.alarms.length > 0 && !this.scrollListener) {
        setTimeout(() => this.setupInfiniteScroll(), 200);
      }
    }
  }

  private initializeColumns(): void {
    const preferredKeys = [
      'assetId',
      'eventName'
    ];

    this.allAvailableColumns = [
      'assetId',
      'assetName',
      'eventName',
      'location',
      'inputDate',
      'reportDate'
    ];

    this.columnLabels = {
      assetId: 'Asset ID',
      assetName: 'Nombre',
      eventName: 'Evento',
      latitude: 'Latitud',
      longitude: 'Longitud',
      location: 'Ubicación',
      speed: 'Velocidad',
      heading: 'Rumbo',
      inputDate: 'Fecha de Ingreso',
      reportDate: 'Fecha de Reporte'
    };

    this.allAvailableColumns.forEach(col => {
      this.visibleColumns[col] = preferredKeys.includes(col) && this.displayedPositions.some(row => row[col] !== undefined && row[col] !== '');
    });

    this.updateVisibleColumns();
  }

  private processPositions(): void {
    
    // Procesar posiciones para displayedPositions
    this.displayedPositions = this.lastPositions ? [...this.lastPositions] : [];

    // Inicializar el arreglo de alarmas
    this.alarmasDisplayHoy = [];

    if (!this.alarmsByAssetId) {
      this.initializeColumns();
      return;
    }

    // Recorrer alarmsByAssetId y añadir la primera alarma de cada asset
    Object.keys(this.alarmsByAssetId).forEach(assetId => {
      const alarmsArray = this.alarmsByAssetId[assetId];


      

      if (alarmsArray && alarmsArray.length > 0) {
        const firstAlarm = alarmsArray[0];

        // Añadir la alarma al arreglo alarmasDisplayHoy
        const alarmToAdd = {
          id: assetId,
          ...firstAlarm
        };

        this.alarmasDisplayHoy.push(alarmToAdd);
      }
    });

    

    this.initializeColumns();
    
    // Emitir evento solo si displayedPositions cambió
    if (JSON.stringify(this.displayedPositions) !== JSON.stringify(this.previousDisplayedPositions)) {
      this.previousDisplayedPositions = [...this.displayedPositions];
      this.lastPositionsUpdated.emit(this.displayedPositions);
    }
  }

  toggleColumnVisibility(column: string): void {
    this.visibleColumns[column] = !this.visibleColumns[column];
    this.updateVisibleColumns();
  }

  private updateVisibleColumns(): void {
    this.columns = this.allAvailableColumns.filter(col => this.visibleColumns[col]);
  }

  sortTable(column: string): void {
    if (this.sortBy === column) {
      // Toggle sort direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // New column selected
      this.sortBy = column;
      this.sortDirection = 'asc';
    }

    this.displayedPositions.sort((a: any, b: any) => {
      const valueA = a[column];
      const valueB = b[column];

      if (valueA == null && valueB == null) return 0;
      if (valueA == null) return this.sortDirection === 'asc' ? 1 : -1;
      if (valueB == null) return this.sortDirection === 'asc' ? -1 : 1;

      let comparison = 0;
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.localeCompare(valueB);
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else {
        comparison = String(valueA).localeCompare(String(valueB));
      }

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
    
    // Emitir evento solo si displayedPositions cambió después del sort
    if (JSON.stringify(this.displayedPositions) !== JSON.stringify(this.previousSortedPositions)) {
      this.previousSortedPositions = [...this.displayedPositions];
      this.lastPositionsUpdated.emit(this.displayedPositions);
    }
  }

  onVehicleSelected(position: any): void {

    // onVehicleSelected invoked (logs removed)

    
    const latitude = parseFloat(position.latitude);
    const longitude = parseFloat(position.longitude);
    
    if (!isNaN(latitude) && !isNaN(longitude)) {
      this.vehicleSelected.emit({
        latitude,
        longitude,
        assetName: position.assetName || 'Vehículo',
        assetId: position.assetId || `${latitude}-${longitude}`
      });
    }
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getTextColor(hex: string): string {
    if (!hex || hex.length !== 7) return 'black';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminosity > 0.5 ? 'black' : 'white';
  }

  /**
   * Devuelve el color para el texto/ícono de la etiqueta de revisión.
   * Usa `alarm.color` cuando está presente; si es blanco, devuelve negro.
   * Si no hay color definido, devuelve un azul por defecto.
   */
  getReviewTextColor(alarm: any): string {
   
    try {
      const c = alarm?.color;
      if (!c) return '#3b82f6'; // blue-500 por defecto
      const norm = String(c).trim().toLowerCase();
      if (norm === '#fff' || norm === '#ffffff' || norm === 'white' || norm === 'rgb(255,255,255)') return '#000000';
      return c;
    } catch (e) {
      return '#3b82f6';
    }
  }

  /**
   * Devuelve el color para el icono principal de la tarjeta de alarma.
   * Usa `alarm.color` salvo que sea blanco (o equivalentes), en cuyo caso
   * se devuelve '#172c41' como color por defecto legible.
   */
  getIconColor(alarm: any): string {
    try {
      const c = alarm?.color;
      if (!c) return '#172c41';
      const norm = String(c).trim().toLowerCase();
      if (norm === '#fff' || norm === '#ffffff' || norm === 'white' || norm === 'rgb(255,255,255)') return '#172c41';
      return c;
    } catch (e) {
      return '#172c41';
    }
  }

  trackById(index: number, item: any): any {
    return item.id;
  }

  // Modal de clasificación
  showClassificationModal: boolean = false;
  modalAlarm: any = null;

  openClassificationModal(alarm: any): void {
    this.modalAlarm = alarm;
    this.showClassificationModal = true;
    // resetear/inyectar valores en el formulario
    if (this.classificationForm) {
      this.classificationForm.reset({ status: '', observations: '', bulkClassification: false });
      this.errorMessage = null;
      this.successMessage = null;
    }
  }

  closeClassificationModal(): void {
    this.modalAlarm = null;
    this.showClassificationModal = false;
  }

  clasificarAlerta(position: any): void {
    if (this.classificationForm && this.classificationForm.invalid) {
      this.classificationForm.markAllAsTouched();
      this.errorMessage = 'Por favor complete el formulario.';
      return;
    }

    if (!this.monitorId) {
      this.errorMessage = 'MonitorId no disponible. No se puede clasificar.';
      return;
    }

    const isBulk = !!this.classificationForm.get('bulkClassification')?.value;
    const selectedAlarms = this.bulkAlarms.filter(a => a.id && this.selectedAlarmIds.has(a.id));

    if (isBulk && selectedAlarms.length === 0) {
      this.errorMessage = 'Debe seleccionar al menos una alarma para clasificación por lote.';
      return;
    }

    const classificationData = {
      alarmIds: isBulk ? selectedAlarms.map((a: any) => a.id) : (position.id ? [position.id] : []),
      status: this.classificationForm.get('status')?.value,
      observations: this.classificationForm.get('observations')?.value || ''
    };

    this.alarmsService.doBulkClassification(classificationData, this.monitorId).subscribe({
      next: () => {
        this.successMessage = `Clasificación aplicada a ${classificationData.alarmIds.length} alarma(s) correctamente`;
        this.errorMessage = '';
        this.closeClassificationModal();
      },
      error: () => {
        this.errorMessage = 'Error al clasificar las alarmas';
        this.successMessage = '';
      }
    });
  }

  onBulkChange(): void {
    const checked = !!this.classificationForm.get('bulkClassification')?.value;
    if (!checked) {
      this.bulkAlarms = [];
      this.selectedAlarmIds.clear();
      this.bulkCurrentPage = 0;
      this.bulkHasMorePages = false;
      this.bulkTotalElements = 0;
      return;
    }

    if (!this.monitorId) {
      this.errorMessage = 'MonitorId no disponible. No se puede cargar alarmas.';
      return;
    }

    // Reset y cargar primera página
    this.bulkAlarms = [];
    this.selectedAlarmIds.clear();
    this.bulkCurrentPage = 0;
    this.loadBulkAlarmsPage(0);
  }

  loadBulkAlarmsPage(page: number): void {
    if (!this.monitorId || this.isLoadingBulkAlarms) return;

    const eventId = this.modalAlarm?.gpsReport?.eventId || this.modalAlarm?.eventId || null;
    const filters: any = {};
    if (eventId) filters.eventId = eventId;

    this.isLoadingBulkAlarms = true;
    this.alarmsService.getAlarms(this.monitorId, page, this.pageSize, filters).subscribe({
      next: (response: AlarmsResponse) => {
        const newAlarms = response.content || [];
        this.bulkAlarms = page === 0 ? newAlarms : [...this.bulkAlarms, ...newAlarms];
        this.bulkCurrentPage = response.number ?? page;
        this.bulkHasMorePages = !response.last;
        this.bulkTotalElements = response.totalElements ?? 0;
        this.isLoadingBulkAlarms = false;
        this.errorMessage = null;
      },
      error: (_err: any) => {
        this.errorMessage = 'Error al cargar las alarmas';
        this.isLoadingBulkAlarms = false;
      }
    });
  }

  onBulkListScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const threshold = 100;
    const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    if (distanceToBottom <= threshold && !this.isLoadingBulkAlarms && this.bulkHasMorePages) {
      this.loadBulkAlarmsPage(this.bulkCurrentPage + 1);
    }
  }

  // ---- Selección de alarmas para bulk ----

  toggleAlarmSelection(alarmId: string): void {
    if (this.selectedAlarmIds.has(alarmId)) {
      this.selectedAlarmIds.delete(alarmId);
    } else {
      this.selectedAlarmIds.add(alarmId);
    }
  }

  selectAllBulkAlarms(): void {
    this.bulkAlarms.forEach(a => {
      if (a.id) this.selectedAlarmIds.add(a.id);
    });
  }

  deselectAllBulkAlarms(): void {
    this.selectedAlarmIds.clear();
  }

  get allBulkSelected(): boolean {
    return this.bulkAlarms.length > 0 && this.bulkAlarms.every(a => !a.id || this.selectedAlarmIds.has(a.id));
  }

  // ---- Infinite Scroll ----

  private setupInfiniteScroll(): void {
    // Esperar a que el ViewChild esté disponible
    setTimeout(() => {
      const container = this.scrollContainer?.nativeElement;
      if (!container) return;

      this.scrollListener = () => this.onScroll(container);
      container.addEventListener('scroll', this.scrollListener, { passive: true });
    }, 300);
  }

  private removeScrollListener(): void {
    if (this.scrollListener && this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null;
    }
  }

  private onScroll(container: HTMLDivElement): void {
    const threshold = 100; // px antes del fondo para disparar carga
    const distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;

    if (distanceToBottom <= threshold && !this.isLoadingAlarms && this.hasMoreAlarms) {
      this.loadMoreAlarms.emit();
    }
  }

  get hasMoreAlarms(): boolean {
    return this.alarms.length < this.totalAlarms;
  }

  onAlarmCardClick(alarm: any): void {


  // Alarm card clicked (logs removed)
  // Marcar localmente la alarma seleccionada para que la UI refleje el cambio inmediatamente
  try {
    this.selectedAlarmId = alarm.id;
  } catch (e) {
    // ignore
  }
    const gps = alarm?.gpsReport;
    if (!gps) {    
      return;
    }

    const latitude = parseFloat(gps.latitude);
    const longitude = parseFloat(gps.longitude);
  
    // GPS data resolved (log removed)
    if (!isNaN(latitude) && !isNaN(longitude)) {
      // Si el padre pasó una función para manejar el click, ejecútala primero
      try {
        if (this.onRowClick) {
          // Invocar onRowClick antes de emitir vehicleSelected (log removed)
          this.onRowClick({ alarm, source: 'lastposicion' });
        }
      } catch (e) {
        // ignore
      }

      this.vehicleSelected.emit({
        latitude,
        longitude,
        assetName: gps.assetName || 'Vehículo',
        assetId: gps.assetId || `${latitude}-${longitude}`, 
        color: alarm.color || '#172c41',
        alarmData: {
          eventName: gps.eventName || 'Evento',
          location: gps.location || 'Sin ubicación',
          reportDate: gps.reportDate || '',
          speed: gps.speed,
          status: alarm.status || 'N/A'
        }
      });
     }
  }

  // ---- Filtros de alarmas ----

  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  /** Extraer lista de unidades únicas de lastPositions */
  private updateAvailableUnits(): void {
    const seen = new Set<string>();
    const units: { assetId: string; assetName: string }[] = [];

    (this.lastPositions || []).forEach((pos: any) => {
      const id = pos.assetId;
      if (id && !seen.has(id)) {
        seen.add(id);
        units.push({ assetId: id, assetName: pos.assetName || id });
      }
    });

    units.sort((a, b) => a.assetName.localeCompare(b.assetName));
    this.availableUnits = units;
  }

  // Internal helper: set de assetIds derivado de alarm IDs marcadas como nuevas
  private _newAlarmAssetIds: Set<string> = new Set();
  // assetId resuelto a partir de `selectedAlarmId` (si es necesario)
  private _selectedAssetId: string | null = null;

  public isAssetNew(assetId: string | null | undefined): boolean {
    if (!assetId) return false;
    if (this._newAlarmAssetIds && this._newAlarmAssetIds.has(assetId)) return true;
    // Si el parent pasa assetIds directamente dentro de newAlarmIds, soportarlo también
    if (this.newAlarmIds && this.newAlarmIds.has(assetId as any)) return true;
    return false;
  }

  /**
   * Resuelve `selectedAlarmId` (puede ser alarmId o assetId) a un `assetId` y
   * emite `vehicleSelected` para centrar el mapa en la última posición conocida.
   */
  private updateSelectedFromInput(): void {
    this._selectedAssetId = null;
    if (!this.selectedAlarmId) return;

    const sel = String(this.selectedAlarmId).trim();

    // Si coincide directamente con alguna lastPosition.assetId, tomarla
    const fromLastPos = (this.lastPositions || []).find(p => String(p?.assetId || '').trim() === sel);
    if (fromLastPos && fromLastPos.assetId) {
      this._selectedAssetId = String(fromLastPos.assetId).trim();
      const lat = parseFloat(fromLastPos.latitude);
      const lon = parseFloat(fromLastPos.longitude);
      if (!isNaN(lat) && !isNaN(lon)) {
        this.vehicleSelected.emit({ latitude: lat, longitude: lon, assetName: fromLastPos.assetName || this._selectedAssetId, assetId: this._selectedAssetId });
      }
      return;
    }

    // Si no, buscar en `alarms` por alarm.id y extraer gpsReport.assetId
    if (this.alarms && this.alarms.length > 0) {
      const alarmMatch = this.alarms.find(a => a && String(a.id).trim() === sel);
      if (alarmMatch) {
        const assetId = alarmMatch.gpsReport?.assetId || alarmMatch.deviceId || null;
        if (assetId) {
          this._selectedAssetId = String(assetId).trim();
          // intentar obtener coords desde lastPositions
          const pos = (this.lastPositions || []).find(p => String(p?.assetId || '').trim() === this._selectedAssetId);
          if (pos && pos.latitude && pos.longitude) {
            const lat = parseFloat(pos.latitude);
            const lon = parseFloat(pos.longitude);
            if (!isNaN(lat) && !isNaN(lon)) {
              this.vehicleSelected.emit({ latitude: lat, longitude: lon, assetName: pos.assetName || this._selectedAssetId, assetId: this._selectedAssetId });
            }
          }
        }
      }
    }
  }

  /** Comprueba si un assetId coincide con el asset seleccionado */
  public isAssetSelected(assetId: string | null | undefined): boolean {
    if (!assetId) return false;
    const a = String(assetId).trim();
    if (this._selectedAssetId && String(this._selectedAssetId).trim() === a) return true;
    // también permitir que selectedAlarmId sea directamente el assetId
    if (this.selectedAlarmId && String(this.selectedAlarmId).trim() === a) return true;
    return false;
  }

  /** Getter para filtrar unidades disponibles por texto de búsqueda */
  get filteredUnits(): { assetId: string; assetName: string }[] {
    const text = this.unitSearchText.trim().toLowerCase();
    if (!text) return this.availableUnits;
    return this.availableUnits.filter(u =>
      u.assetId.toLowerCase().includes(text) || u.assetName.toLowerCase().includes(text)
    );
  }

  toggleUnit(assetId: string): void {
    if (this.selectedUnits.has(assetId)) {
      this.selectedUnits.delete(assetId);
    } else {
      this.selectedUnits.add(assetId);
    }
    this.applyFilters();
  }

  selectAllUnits(): void {
    this.filteredUnits.forEach(u => this.selectedUnits.add(u.assetId));
    this.applyFilters();
  }

  deselectAllUnits(): void {
    this.selectedUnits.clear();
    this.applyFilters();
  }

  /** Aplicar filtros locales sobre las alarmas ya cargadas */
  applyFilters(): void {
    let result = this.alarms;
    const text = this.filterText.trim().toLowerCase();

    if (text) {
      result = result.filter(alarm => {
        const assetId = (alarm.gpsReport?.assetId || '').toLowerCase();
        const assetName = (alarm.gpsReport?.assetName || '').toLowerCase();
        const eventName = (alarm.gpsReport?.eventName || '').toLowerCase();
        const location = (alarm.gpsReport?.location || '').toLowerCase();
        return assetId.includes(text)
          || assetName.includes(text)
          || eventName.includes(text)
          || location.includes(text);
      });
    }

    if (this.selectedUnits.size > 0) {
      result = result.filter(alarm => this.selectedUnits.has(alarm.gpsReport?.assetId));
    }

    this.filteredAlarms = result;

    // Emitir IDs de assets filtrados para sincronizar markers del mapa
    if (this.hasActiveFilters) {
      const assetIds = [...new Set(result.map(a => a.gpsReport?.assetId).filter(Boolean))];
      this.filteredAssetIdsChange.emit(assetIds);
    } else {
      this.filteredAssetIdsChange.emit(null); // null = mostrar todos
    }
  }

  clearFilters(): void {
    this.filterText = '';
    this.selectedUnits.clear();
    this.unitSearchText = '';
    this.applyFilters();
  }

  get hasActiveFilters(): boolean {
    return this.filterText.trim() !== '' || this.selectedUnits.size > 0;
  }
}